import { Shield, Wrench, MessageSquare, FileCheck } from "lucide-react"
import { useLanguage } from "@/contexts/LanguageContext"

const GuaranteesSection = () => {
  const { t } = useLanguage()
  
  const guarantees = [
    {
      icon: Shield,
      title: t('guarantees.quality'),
      description: t('guarantees.quality.desc'),
      color: "text-green-600"
    },
    {
      icon: Wrench,
      title: t('guarantees.custom'),
      description: t('guarantees.custom.desc'),
      color: "text-blue-600"
    },
    {
      icon: MessageSquare,
      title: t('guarantees.professionalism'),
      description: t('guarantees.professionalism.desc'),
      color: "text-purple-600"
    },
    {
      icon: FileCheck,
      title: t('guarantees.ip'),
      description: t('guarantees.ip.desc'),
      color: "text-orange-600"
    }
  ]

  return (
    <section className="py-20 bg-je-gray-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-je-black mb-4">
            {t('guarantees.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('guarantees.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {guarantees.map((guarantee, index) => (
            <div
              key={index}
              className="text-center p-6 bg-je-white rounded-xl shadow-card hover:shadow-hover transition-all duration-300 card-hover scroll-reveal"
              style={{animationDelay: `${index * 120}ms`}}
            >
              <div className="mb-6">
                <guarantee.icon className={`h-16 w-16 ${guarantee.color} mx-auto`} />
              </div>
              <h3 className="text-2xl font-bold text-je-black mb-4">
                {guarantee.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {guarantee.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GuaranteesSection